import apiURL, { domain } from "@/apiURL";
import { constructQueryParams } from "../validation/Validators";
import axios from "axios";
import cleanDeep from "clean-deep";

const isLocal = domain === "local";

const createRequest = ({ urlPath, local }) => {
	return (params) => {
		if (localStorage.getItem("DIRECT_TO_LOCAL")) local = true;
		if (!isLocal) local = false;

		const { body, path, method, query, url, onUploadProgress, org } = params;
		const API = local ? "http://localhost:3001" : apiURL;

		const contentType = body instanceof Object ? "application/json" : undefined;
		const accept = body instanceof Object ? "application/json" : undefined;

		const headers = cleanDeep({
			"Content-Type": contentType,
			"Accept": accept,
			// "User-Agent": "BuddyPayroll" // ! disabled due to unsafe header warning
		});

		if (org) headers["buddy-organisation"] = org;

		return axios({
			method: method,
			url: `${url ? url : `${API}${urlPath}${path}`}${constructQueryParams(query)}`,
			data: body,
			withCredentials: true,
			onUploadProgress,
			headers,
		});
	};
};

const settingsRequest = createRequest({
	urlPath: "/settings",
	local: false,
});

const checkExecutionRequest = (arn) => {
	return settingsRequest({
		method: "GET",
		path: `/describe-execution/${arn}`,
	});
};

const pdfRequest = createRequest({
	urlPath: "/settings/pdf",
	// local: true,
});

const checkExecutionLoop = async (arn) => {
	await new Promise((resolve) => setTimeout(resolve, 1000));
	let response = await checkExecutionRequest(arn);

	const { status } = response.data.data;
	const finished = status !== "RUNNING";

	if (!finished) {
		response = await checkExecutionLoop(arn);
	}

	return response;
};

const checkExecutionStatus = (arn) => {
	return new Promise(async (resolve, reject) => {
		try {
			const response = await checkExecutionLoop(arn);
			const { status } = response.data.data;

			const responseData = response.data.data;
			if (responseData.input) responseData.input = JSON.parse(responseData.input);
			if (responseData.output) responseData.output = JSON.parse(responseData.output);
			if (responseData.cause) responseData.cause = JSON.parse(responseData.cause.replaceAll(/\\n/g, "\n"));

			if (status === "SUCCEEDED") {
				resolve(responseData);
			} else {
				reject(response.data);
			}
		} catch (error) {
			console.error(error);
			reject();
		}
	});
};

export { createRequest, settingsRequest, checkExecutionStatus, pdfRequest };
